export default __webpack_public_path__ + "static/18-8632ff8e3080c32b220ecd946c554307.webp";